<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar title="Matchade chaufförer" :showBackButton="true" :isEdit="false"></app-view-toolbar>
    <v-data-table
      v-if="viewDataIsLoaded"
      :headers="viewData.driverListData.header_ar"
      :items="viewData.driverListData.item_ar"
      :items-per-page="10"
      :hide-default-header="viewData.driverListData.item_ar.length == 0"
      :hide-default-footer="viewData.driverListData.item_ar.length == 0"
      @click:row="showDriver"
      class="xClickRowTable"
    >
      <template v-slot:top>
        <v-toolbar
          dense
          flat
          color="white"
        >
          <v-toolbar-title class="text-h6">
            {{ assignmentName }}
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <!--contactStatus:header-->
      <template v-if="!viewData.freeDriverAccess" v-slot:[`header.contactStatus`]="">
        <v-icon>
          mdi-account-box-outline
        </v-icon>
      </template>
      <!--contactStatus:item-->
      <template v-if="!viewData.freeDriverAccess" v-slot:[`item.contactStatus`]="{ item }">
        <v-icon
          v-if="item.contactStatus == 'notAvailable'"
        >
          mdi-cancel
        </v-icon>
        <v-icon
          v-else-if="item.contactStatus == 'accessable'"
        >
          mdi-check
        </v-icon>
        <v-icon
          v-else-if="item.contactStatus == 'available'"
        >
          mdi-plus
        </v-icon>
      </template>
      <!--hasSigned-->
      <template v-slot:[`item.hasSigned`]="{ item }">
        <v-tooltip
          left
          dark
          color="accent"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="item.hasSigned"
              color="accent"
            >
              mdi-check
            </v-icon>
            <div
              v-else
            >
              Nej
            </div>
          </template>
          <span v-show="item.hasSigned">Signerade {{ item.signedDate }}</span>
        </v-tooltip>
      </template>
      <!--no-data-->
      <template v-slot:no-data>
        <div class="text-left">
          Inga chaufförer matchar jobbet
        </div>
      </template>
    </v-data-table>
    <!--buyProfileAccessDialog-->
    <v-dialog
      v-model="buyProfileAccessDialog"
      max-width="320"
      dark
    >
      <v-card>
        <v-card-title class="headline">Köp åtkomst</v-card-title>
        <v-card-text
          v-if="buyProfileAccessDialog"
        >
          <div>Det är gratis att se chaufförens profil först när denne signerat jobbet, men du om du vill kan du köpa åtkomst redan nu (debiteras via månadsfaktura)</div>
          <div class="font-weight-bold mt-2">Chaufför</div>
          <div>{{ contactAccessDriverInProgress.name }}, {{ contactAccessDriverInProgress.city }}</div>
          <div class="font-weight-bold mt-2">Pris</div>
          <div>{{ viewData.profileAccessPriceFormatted }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="buyProfileAccessDialog = false"
          >
            Avbryt
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="buyProfileAccess()"
          >
            Köp
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--loader-->
    <v-overlay
      :value="loader"
      opacity="0.8"
      z-index="1001"
    >
      <v-progress-circular
        :size="60"
        color="secondary"
        indeterminate
        :rotate="-90"
      >
      </v-progress-circular>
    </v-overlay>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'MatchedDrivers',
  components: {
    'app-snack-bar': SnackBar,
    'app-view-toolbar': ViewToolbar
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      viewDataIsLoaded: false,
      viewData: {},
      buyProfileAccessDialog: false,
      contactAccessDriverInProgress: null,
      loader: false
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData', 'isGreen']),
    assignmentName() {
      return this.viewDataIsLoaded ? this.viewData.assignmentData.name : ''
    }
  },
  methods: {
    isAccessable(item) {
      return item.hasSigned || item.contactStatus == 'accessable'
    },
    onViewData(viewData) {
      this.viewData = viewData
      this.viewDataIsLoaded = true
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        cmpId: this.loggedInData.agentData.id
      }
      let url = this.url_composeApiUrl('/assignment/matched-drivers/' + this.id)
//      console.log('matched-drivers', url)
//      console.log('postData', postData)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('matched-drivers response', response)
          if (response.data.success) {
            //success
            this.onViewData(response.data.returnData.viewData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    showDriver(item) {
      if (this.isAccessable(item)) {
        this.openDriver(item.uuid)
      } else {
        switch (item.contactStatus) {
          case 'notAvailable':
            snackBarBus.$emit('message', 'Chauffören tillåter ej visning av sina kontaktuppgifter förrän denne signerat jobbet')
          break;
          case 'available':
            this.contactAccessDriverInProgress = item
            this.buyProfileAccessDialog = true
          break;
        }
      }
    },
    openDriver(uuid) {
      //open driver by its uuid and also send the uuid for the assignment in order to know which assignment to sign the driver for
      this.$router.push({ name: 'driver', params: { uuid: uuid }, query: { asgUuid: this.viewData.assignmentData.uuid } })
    },
    buyProfileAccess() {
      this.loader = true
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        usrId: this.loggedInData.userData.id,
        cmpId: this.loggedInData.agentData.id,
        drvUuid: this.contactAccessDriverInProgress.uuid,
        asgUuid: this.viewData.assignmentData.uuid
      }
      let url = this.url_composeApiUrl('/assignment/buy-profile-access')
//      console.log('buy-profile-access', url)
//      console.log('postData', postData)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('buy-profile-access response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //"reload" viewData
            this.onViewData(response.data.returnData.viewData)
            //open driver
            this.openDriver(this.viewData.drvUuidToOpen)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    }
  },
  created() {
    //get viewData
    this.loadViewData()
  }
}
</script>

<style>
</style>